import { call, put } from 'typed-redux-saga'
import * as psd2ConsentActions from '../../actions/consumerDataPullSessionActions/psd2ConsentActions'
import { transactionApiClient } from '../../../../../api/transactionApiClient'

export function* createPsd2ConsentSaga(): Generator {
	try {
		yield put(psd2ConsentActions.clearErrors())
		const token: string = yield* call(transactionApiClient.createPsd2Consent)
		yield put(psd2ConsentActions.createPsd2ConsentSucceeded(token))
	} catch (error: any) {
		yield put(psd2ConsentActions.createPsd2ConsentFailed(error))
	}
}
